import {
  useEffect,
  useState,
} from 'react'

import {
  useLAIAActivity,
} from './ActivityContext'

function formatElapsed(
  milliseconds: number,
) {
  const seconds =
    Math.max(
      0,
      Math.floor(
        milliseconds /
          1000,
      ),
    )

  const minutes =
    Math.floor(
      seconds /
        60,
    )

  const remainder =
    seconds %
    60

  return (
    `${String(minutes).padStart(2, '0')}:` +
    `${String(remainder).padStart(2, '0')}`
  )
}

export function LAIAActivityPulse() {
  const {
    activity,
  } =
    useLAIAActivity()

  const [
    now,
    setNow,
  ] =
    useState(
      Date.now(),
    )

  useEffect(() => {
    if (
      activity.startedAt === null
    ) {
      return
    }

    const timer =
      window.setInterval(
        () =>
          setNow(
            Date.now(),
          ),
        1000,
      )

    return () =>
      window.clearInterval(
        timer,
      )
  }, [
    activity.startedAt,
  ])

  const active =
    ![
      'IDLE',
      'COMPLETE',
      'ERROR',
    ].includes(
      activity.phase,
    )

  const elapsed =
    activity.startedAt
      ? formatElapsed(
          now -
            activity.startedAt,
        )
      : null

  return (
    <div
      className={
        `r7-laia-pulse phase-${activity.phase.toLowerCase()}`
      }
    >

      <span
        className={
          active
            ? 'r7-pulse-dot active'
            : 'r7-pulse-dot'
        }
      />

      <div className="r7-pulse-copy">

        <strong>
          {activity.label}
        </strong>

        {activity.detail && (
          <span>
            {activity.detail}
          </span>
        )}

      </div>

      {
        activity.step !== undefined &&
        activity.totalSteps !== undefined
        && (
          <span className="r7-stage">
            {activity.step}/
            {activity.totalSteps}
          </span>
        )
      }

      {
        typeof activity.progress ===
          'number'
        && (
          <div className="r7-progress">
            <span
              style={{
                width:
                  `${Math.max(
                    0,
                    Math.min(
                      100,
                      activity.progress,
                    ),
                  )}%`,
              }}
            />
          </div>
        )
      }

      {elapsed && (
        <time>
          {elapsed}
        </time>
      )}

    </div>
  )
}
